module.exports = __webpack_public_path__ + "static/tempo-demo-c85a1c065228b9a4614bf90c25d8c487.mp4";